import React from "react";
import { useSelector } from "react-redux";

const DataTableWithoutPagination = (props) => {
  const { columns, data } = props;

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );

  return (
    <div className="w-100 react-datatable-without-pagination">
      <table dir={direction} className="table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th
                key={column.id}
                className={`font-15 ${
                  column.id === "actions" ? "text-center" : ""
                }`}
              >
                {column.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column) => (
                <td key={`${column.id}-${rowIndex}`}>
                  {typeof column.selector === "function"
                    ? column.selector(row, rowIndex)
                    : row[column.selector]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTableWithoutPagination;
